module.exports = __webpack_public_path__ + "static/media/play-undo.32ae2f85.mp3";